import { useMemo } from 'react';
import { Box, Grid } from '@mui/material';

const CarsStatistics = ({ cars, data, dayStart, dayEnd }) => {
  const carsBase = useMemo(() => {
    return cars.reduce((acc, car) => {
      return {
        ...acc,
        [car._id]: {
          plate: car.plate,
          stats: {
            costPln: 0,
            costEur: 0,
            carriageNumber: 0,
          },
        },
      };
    }, {});
  }, [cars]);

  const stats = useMemo(() => {
    const safeData = Array.isArray(data) ? data : [];
    const carData = safeData.reduce((acc, value) => {
      const carId = value?.car?._id ?? value?.car;
      if (!carId || !acc[carId]) {
        return acc;
      }
      const cost = Number(value?.cost) || 0;
      if (value?.currency === 'PLN') {
        acc[carId].stats.costPln += cost;
      } else if (value?.currency === 'EUR') {
        acc[carId].stats.costEur += cost;
      }
      acc[carId].stats.carriageNumber += 1;
      return acc;
    }, { ...carsBase });

    return Object.values(carData).sort((...args) => {
      const [a, b] = args.map(({ plate }) => plate.toUpperCase().replace(/\s+/g, ''));
      return a.localeCompare(b, 'pl-PL', { sensitivity: 'base' });
    });
  }, [data, carsBase]);

  return (
    <Grid container sx={12} style={{ gap: '15px' }}>
      {stats.map((car, index) => {
        return (
          <Grid item key={index} sx={12} style={{ border: '1px solid grey', borderRadius: '10px', width: '100%' }}>
            <Box style={{ display: 'flex', alignItems: 'center' }}>
              <Box style={{ width: '80px', color: 'white', margin: '25px' }}>{car.plate}</Box>
              <Box style={{ marginLeft: '15px' }}>
                <Box style={{ color: 'white' }}>Wykonane transporty: {car.stats.carriageNumber}</Box>
                <Box style={{ color: 'white' }}>
                  Suma: {car.stats.costPln.toFixed(2)} zł | {car.stats.costEur.toFixed(2)} €
                </Box>
              </Box>
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};

export { CarsStatistics };
